import { useQuery } from '@tanstack/react-query'
import { getShipstationQuotes } from '@api/getShipstationQuotes'
import type {
  GetShipstationQuotesPayload,
  ShipstationQuote,
} from '@api/getShipstationQuotes'

export const useGetShipstationQuotes = (
  payload: GetShipstationQuotesPayload,
) =>
  useQuery<{ data: ShipstationQuote[]; error: boolean }, Error>({
    queryKey: ['shipstation-quotes', payload],
    queryFn: () => getShipstationQuotes(payload),
    enabled: false,
    retry: 1, // Only retry once instead of default 3 times
    retryDelay: 1000, // Wait 1 second before retry
    staleTime: 0, // Don't cache the result
    gcTime: 0, // Don't keep in cache
  })

